import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InvoiceFinderContextService {
  private selectedInvoices: number[] = [];
  private writeOffOpen = false;

  public setSelectedInvoices(invoices: number[]): void {
    this.selectedInvoices = invoices;
  }

  public getSelectedInvoices(): Promise<number[]> {
    return Promise.resolve(this.selectedInvoices);
  }

  public setWriteOffOpen(open: boolean): void {
    this.writeOffOpen = open;
  }

  public isWriteOffOpen(): boolean {
    return this.writeOffOpen;
  }
}
